import React from 'react'
import eegWorm from "../assets/eegg-worm.png";
import plane3 from "../assets/eegg-plane3-dirty.png";
import shelf from "../assets/Shelf_CP.png";
import commonChart from '../assets/Common chart.png'
import rareChart from '../assets/Rare chart.png'
import ultraRare from '../assets/Ultra Rare.png'
import ucChart from '../assets/Uncommon chart.png'
const cpGif = require('../assets/CP rotating gif.GIF')



function Rarity() {

  const RarityType=({type, image})=>{
    return(
      <div  className="rarityTy mt-28 pt-[-200px] lg:mt-44">
        <div className="typeHead ml-10 text-white text-left text-[20px]  font-title lg:text-[40px] ">
          {type}
          </div>
          <div className="chart">
            <img src={image} className={`object-contain w-[250px] ml-11 mt-4 ${type==='UNCOMMON'?'ml-[-5px]':''} lg:w-[500px]  `} alt="" />
            </div>
        </div>
    )
  }
  return (
    <div className="Utility utilityBG p-24 pl-2 pr-0 pt-5 lg:p-32 lg:pt:10 mt-[-12px] ">
    {/* <div className="utilityTopImg flex justify-start w-20">
      <img src={eegWorm} className="w-20 -rotate-[60deg]" alt="" />
    </div> */}

    <div id="rarity_id" className="utilityHeading text-white text-[14px] text-left mb-0 ml-5 mt-10 font-title lg:text-[45px] lg:ml-10">
      RARITY
    </div>


    {/* text left heading */}
    <div className="flex font-early ">
      <div className="utilityLeft m-5 mt-2 relative lg:m-10">
          <img src={plane3} className='w-16 absolute top-[-4rem] right-0 z-0  rotate-6 opacity-70 lg:w-32 lg:top-[-2rem] ' alt="" />
          <img src={eegWorm} className="w-14 absolute bottom-[-2rem] left-[-4rem] lg:w-20 " alt="" />
          <div className='text-left text-[9px] lg:text-[15px]' >
		<span className="text-[rgba(255,255,124,1)] text-[8px] relative z-10 lg:text-[15px] ">Coin Plants feature 8 unique properties </span><span className="text-[rgba(255,255,255,1)] relative z-10 lg:text-[15px]">with property 1 being a set of 17 beautiful backgrounds and property 8 being extremely rare! <br/><br/>Every other Coin Plant property contains at least </span><span className="text-[rgba(255,255,124,1)] lg:text-[15px]  relative z-10">26 variable colour variations</span><span className="text-[rgba(255,255,255,1)]  relative z-10 lg:text-[15px]" > which make up the complete design, each representing the colour scheme of a blue chip Cryptocurrency. <br/><br/>Almost every Coin Plant is randomised, but </span><span className="text-[#7BD98D]  relative z-10 lg:text-[15px]">there are a handful of custom 1 of 1 designs</span><span className="text-[rgba(255,255,255,1)]  relative z-10 lg:text-[15px]"> amongst collection, so keep an eye out for those!</span>
	</div>
      </div>

      <div className="utilityRight  hidden sm:block m-10 mr-0 w-[100%]">
       {/* <img src={shelf} className='mt-[-10rem]' alt="" /> */}
       <img className="w-[15rem] ml-[auto] mr-[auto] rounded-[4rem] hidden sm:block sm:w-32 lg:w-56 " src={cpGif} alt="" /> 
      </div>
      {/* utility right text end */}
    </div>

    <div id="rarityTypes_id" className="rarityTypes flex flex-wrap justify-between 
    ">
      <RarityType type="ULTRA RARE" image={ultraRare} />
      <RarityType type="RARE" image={rareChart} />
      <RarityType type="UNCOMMON" image={ucChart} />
      <RarityType type="COMMON" image={commonChart} />
      </div>
  </div>
  )
}

export default Rarity